export default "__VITE_ASSET__eRJsSZ$z__"